/** Library, local artwork editor, custom room assets and card backs. */
export const collectionsPtBR: Record<string, string> = {
  "Mes jeux": "Meus jogos",
  "Voir les cartes": "Ver as cartas",
  "Toutes les images": "Todas as imagens",
  "Complète le jeu pour voir les cartes.": "Complete o jogo para ver as cartas.",
  "Ce jeu ne contient pas encore d’images.": "Este jogo ainda não tem imagens.",
  "Jeu sélectionné": "Jogo selecionado",
  "Jeu": "Jogo",
  "Tes images. Tes cartes.": "Suas imagens. Suas cartas.",
  "Créer un jeu": "Criar jogo",
  "Nom du jeu": "Nome do jogo",
  "Mon jeu": "Meu jogo",
  "Mon jeu Náutico": "Meu jogo do Náutico",
  "Images à préparer": "Imagens para preparar",
  "13 images · 4 par carte": "13 imagens · 4 por carta",
  "31 images · 6 par carte": "31 imagens · 6 por carta",
  "57 images · 8 par carte": "57 imagens · 8 por carta",
  "Créer": "Criar",
  "Importer": "Importar",
  "Exporter": "Exportar",
  "Exporter le jeu": "Exportar jogo",
  "Dupliquer le jeu": "Duplicar jogo",
  "Supprimer le jeu": "Excluir jogo",
  "Modifier le jeu": "Editar jogo",
  "Personnaliser ce jeu": "Personalizar este jogo",
  "Prêt à jouer": "Pronto para jogar",
  "Brouillon": "Rascunho",
  "Sélectionné": "Selecionado",
  "Utiliser": "Usar",
  "{count} / {total} images": "{count} / {total} imagens",
  "{count} images": "{count} imagens",
  "Format du jeu": "Tamanho do baralho",
  "Ajoute les images manquantes": "Adicione as imagens que faltam",
  "Ajouter des images": "Adicionar imagens",
  "Enregistrés sur cet appareil. Exporte tes jeux pour les garder ou les partager.": "Salvos neste dispositivo. Exporte seus jogos para guardar ou compartilhar.",
  "Les images sont partagées avec les joueurs de ton salon.": "As imagens são compartilhadas com os jogadores da sua sala.",
  "Jouer à plusieurs": "Jogar com amigos",
  "Dos des cartes": "Verso das cartas",
  "Dos de carte": "Verso da carta",
  "Logo Virou": "Logo Virou",
  "Choisir une image": "Escolher imagem",
  "Recadrer le dos": "Ajustar verso",
  "Couleur du dos": "Cor do verso",
  "Nom du symbole": "Nome do símbolo",
  "Cadrer l’image": "Ajustar imagem",
  "Impossible de lire cette image. Choisis un autre fichier.": "Não foi possível ler esta imagem. Escolha outro arquivo.",
  "Import du jeu…": "Importando jogo…",
  "Déplace l’image pour la recadrer": "Mova a imagem para ajustar o recorte",
  "Glisse l’image pour la déplacer": "Arraste a imagem para mover",
  "Zoom": "Zoom",
  "Recentrer": "Centralizar",
  "Remplacer": "Substituir",
  "Enregistrer l’image": "Salvar imagem",
  "Supprimer l’image": "Excluir imagem",
  "Image {number}": "Imagem {number}",
  "Tu peux encore ajouter {count} images à ce jeu.": "Você ainda pode adicionar {count} imagens a este jogo.",
  "Préparation des images : {current} / {total}": "Preparando imagens: {current} / {total}",
  "Copie des images : {current} / {total}": "Copiando imagens: {current} / {total}",
  "Impossible de copier les illustrations. Réessaie.": "Não foi possível copiar as ilustrações. Tente novamente.",
  "Impossible de modifier ce jeu.": "Não foi possível editar este jogo.",
  "Impossible de modifier cette image.": "Não foi possível editar esta imagem.",
  "Supprimer « {name} » de cet appareil ?": "Excluir “{name}” deste dispositivo?",
  "Retire des images avant de réduire le format du jeu.": "Remova algumas imagens antes de reduzir o tamanho do baralho.",
  "Cette image est trop grande. Choisis une image de moins de 40 mégapixels.": "Esta imagem é grande demais. Escolha uma imagem com menos de 40 megapixels.",
  "Cette image est trop lourde. Choisis une image plus simple.": "Este arquivo de imagem é grande demais. Escolha uma imagem mais simples.",
  "Choisis une image PNG, JPEG ou WebP.": "Escolha uma imagem PNG, JPEG ou WebP.",
  "Chaque fichier image doit peser moins de 12 Mo.": "Cada arquivo de imagem deve ter menos de 12 MB.",
  "Ce fichier ne contient pas un jeu Virou valide.": "Este arquivo não contém um jogo Virou válido.",
  "La taille du jeu doit être 13, 31 ou 57 images.": "O jogo deve ter 13, 31 ou 57 imagens.",
  "Donne un nom de 1 à 60 caractères à ton jeu.": "Dê ao seu jogo um nome de 1 a 60 caracteres.",
  "Chaque image doit avoir un nom de 1 à 60 caractères.": "Cada imagem deve ter um nome de 1 a 60 caracteres.",
  "Les identifiants des images doivent être uniques et se suivre à partir de zéro.": "Os identificadores das imagens devem ser únicos e estar em sequência a partir de zero.",
  "Utilise une image PNG, JPEG ou WebP valide.": "Use uma imagem PNG, JPEG ou WebP válida.",
  "Chaque image doit peser au maximum 200 Ko après recadrage.": "Cada imagem deve ter no máximo 200 KB após o recorte.",
  "L’image d’origine doit peser au maximum 1 Mo.": "A imagem original deve ter no máximo 1 MB.",
  "Le recadrage de cette image est invalide.": "O recorte desta imagem é inválido.",
  "Choisis une couleur et un dos de carte valides.": "Escolha uma cor e um verso de carta válidos.",
  "Ce jeu est trop volumineux pour être partagé. Réduis la taille des images.": "Este jogo é grande demais para compartilhar. Reduza o tamanho das imagens.",
  "Le fichier du jeu doit peser au maximum 32 Mo.": "O arquivo do jogo deve ter no máximo 32 MB.",
  "Ce format de fichier Virou n’est pas pris en charge.": "Este formato de arquivo Virou não é compatível.",
  "Ce jeu doit contenir 13 images pour être joué.": "Este jogo precisa de 13 imagens para jogar.",
  "Ce jeu doit contenir 31 images pour être joué.": "Este jogo precisa de 31 imagens para jogar.",
  "Ce jeu doit contenir 57 images pour être joué.": "Este jogo precisa de 57 imagens para jogar.",
  "Ce jeu n’existe plus.": "Este jogo não existe mais.",
  "Complète toutes les images du jeu avant de le sélectionner.": "Adicione todas as imagens do jogo antes de selecioná-lo.",
  "Tes jeux restent disponibles pour cette session, mais ce navigateur ne permet pas de les enregistrer. Exporte-les pour les conserver.": "Seus jogos continuam disponíveis nesta sessão, mas este navegador não permite salvá-los. Exporte os jogos para guardar.",
  "Impossible d’envoyer ce jeu. Vérifie ta connexion et réessaie.": "Não foi possível enviar este jogo. Verifique sua conexão e tente novamente.",
  "Impossible de charger les images du salon. Vérifie ta connexion et réessaie.": "Não foi possível carregar as imagens da sala. Verifique sua conexão e tente novamente.",
  "L’envoi du jeu prend trop de temps. Réessaie.": "O envio do jogo está demorando demais. Tente novamente.",
  "Le chargement du jeu prend trop de temps. Réessaie.": "O carregamento do jogo está demorando demais. Tente novamente.",
  "Le serveur n’a pas confirmé l’envoi du jeu. Réessaie.": "O servidor não confirmou o envio do jogo. Tente novamente.",
  "Le serveur n’a pas pu charger ce jeu. Réessaie.": "O servidor não conseguiu carregar este jogo. Tente novamente.",
  "Les images de ce salon sont invalides.": "As imagens desta sala são inválidas.",
  "Les images reçues ne correspondent pas à ce salon.": "As imagens recebidas não correspondem a esta sala.",
  "Ce salon n’utilise pas de paquet personnalisé.": "Esta sala não usa um baralho personalizado.",
  "Identifiant du paquet invalide.": "Identificador do baralho inválido.",
  "Ce paquet a expiré. Envoyez-le à nouveau.": "Este baralho expirou. Envie-o novamente.",
  "Le format du salon doit correspondre au paquet personnalisé.": "O tamanho do baralho da sala deve corresponder ao baralho personalizado.",
  "Ce paquet dépasse la limite de 12 Mio.": "Este baralho ultrapassa o limite de 12 MiB.",
  "Le serveur héberge déjà trop de paquets. Réessayez plus tard.": "O servidor já está hospedando muitos baralhos. Tente novamente mais tarde.",
  "Trop de paquets envoyés. Réessayez dans un instant.": "Muitos baralhos enviados. Tente novamente em instantes.",
  "Trop de téléchargements. Réessayez dans un instant.": "Muitos downloads. Tente novamente em instantes.",
  "Le fichier JSON est invalide.": "O arquivo JSON é inválido.",
  "Face de la carte": "Lado da carta",
  "Le symbole {number} manque dans ce jeu.": "O símbolo {number} está faltando neste jogo.",
  "image locale": "imagem local",
  "Choisis recto, recto-verso ou verso.": "Escolha frente, frente e verso ou verso.",
  "Recto": "Frente",
  "Verso": "Verso",
  "Recto et verso": "Frente e verso",
  "Faces à imprimer": "Lados para imprimir",
  "Recto-verso : retourner sur le bord long": "Frente e verso: virar na borda longa",
  "Chargement des images du salon…": "Carregando imagens da sala…",
  "Chargement des images…": "Carregando imagens…",
  "Réessayer": "Tentar novamente",
  "Enregistrer ce jeu": "Salvar este jogo",
  "Jeu ajouté à ta bibliothèque.": "Jogo adicionado à sua biblioteca.",
  "Envoi des images…": "Enviando imagens…",
  "Attends que les images soient chargées chez tous les joueurs.": "Aguarde até que as imagens sejam carregadas para todos os jogadores.",
  "Classique": "Clássico",
  "Personnaliser le jeu classique": "Personalizar o jogo clássico",
  "Choisir dans les jeux": "Escolher nos jogos",
  "La réserve d’images": "Banco de imagens",
  "Pioche dans tous les jeux.": "Escolha imagens de todos os jogos.",
  "Rechercher": "Buscar",
  "Chercher une image…": "Buscar uma imagem…",
  "Jeu d’origine": "Jogo de origem",
  "Tous les jeux": "Todos os jogos",
  "Tout désélectionner": "Desmarcar tudo",
  "Aucune image trouvée.": "Nenhuma imagem encontrada.",
  "Ajouter au jeu": "Adicionar ao jogo",
  "Déjà dans le jeu": "Já está no jogo",
  "{count} / {total} images choisies": "{count} / {total} imagens escolhidas",
  "Sélectionner {count} images": "Selecionar {count} imagens",
  "Impossible de charger cette illustration. Réessaie.": "Não foi possível carregar esta ilustração. Tente novamente.",
  "Ce jeu est complet. Retire une image pour en ajouter une autre.": "Este jogo está completo. Remova uma imagem para adicionar outra.",
  "Ces images sont déjà dans le jeu.": "Estas imagens já estão no jogo.",
};
